import React, { useCallback } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useDropzone } from "react-dropzone";
import { Alert, AlertTitle } from "@mui/material";

export default function InputImage({ values, setValues, preview, setPreview }) {
  const onDrop = useCallback(
    (files) => {
      setPreview(URL.createObjectURL(files[0]));
      setValues({
        ...values,
        image: files,
      });
    },
    [values, setValues, setPreview]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const removeImage = () => {
    setValues({
      ...values,
      image: "",
    });
    setPreview("");
  };

  return (
    <Box display="flex" justifyContent="center" flexDirection="column">
      <Box>
        <Alert severity="info" icon={false}>
          <AlertTitle>Imagen normal</AlertTitle>
          Esta aparecera en computadoras y laptops
        </Alert>
      </Box>
      <Box
        sx={!preview && { border: "dashed 2px", borderColor: "#aaaaaa" }}
        {...getRootProps()}
        height={120}
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <input disabled={values.isModal} {...getInputProps()} />
        {values.image || preview ? (
          <Box
            height={120}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              alt="imagen del curso"
              src={preview}
              style={{ maxHeight: "100%", maxWidth: "100%" }}
            />
          </Box>
        ) : isDragActive ? (
          <Typography>Suelta tú imagen aquí...</Typography>
        ) : (
          <Typography>
            haz clic aquí o arrastra tu imagen y suelta aquí
          </Typography>
        )}
      </Box>
      <Button
        fullWidth
        variant="text"
        color="primary"
        size="small"
        onClick={() => removeImage()}
        disabled={values.isModal}
      >
        Eliminar imagen
      </Button>
    </Box>
  );
}
